<template>
    <registration-form submitButtonText="Зарегистрироваться" @success="isSuccess" >
        <template #offer v-if="false">
            <div class="registration-form__hardware">
                <p>Заполните данные о&nbsp;вашем оборудовании сейчас и&nbsp;получите 200 бонусов на&nbsp;оплату заказа</p>
                <a :href="hardwareLink">Заполнить</a>
            </div>
        </template>
        <template #term>
            <div class="registration-form__hint">
                <p>Нажимая кнопку вы соглашаетесь на&nbsp;обработку ваших персональных данных на&nbsp;следующих <a :href="termsLink" target="_blank">условиях</a>.</p>
            </div>
        </template>

        <template #success>
            <div class="registration-form__success" v-if="success">
                <p>Регистрация прошла успешно!</p>
                <a class="btn btn-block btn-main" href="/personal/profile/">Личный кабинет</a>
            </div>
        </template>
    </registration-form>
</template>

<script>
import { LABS_SETTINGS } from '../../constants';
import { LAB_REDIRECT_URL } from '../../constants/labs';

export default {
    name: 'registration-page',

    data() {
        return {
            success: false,
        };
    },

    props: {
        termsLink: {
            type: String,
            default: '#',
        },
        hardwareLink: {
            type: String,
            default: '#',
        },
    },

    methods: {
        isSuccess() {
            this.success = true;
            const redirectUrl = localStorage.getItem(LAB_REDIRECT_URL);
            localStorage.removeItem(LAB_REDIRECT_URL);

            if (redirectUrl) {
                window.location = redirectUrl;
                return;
            }

            setTimeout(() => {
                const needRedirectToLab = localStorage.getItem(LABS_SETTINGS.openLabsAfterLoginLSKey) && document.referrer.includes('/coffee');

                window.location = needRedirectToLab ? LABS_SETTINGS.lkLabsURL : '/personal/profile/';
            }, 6000);
        },
    },
};
</script>
